import React, {
    useState,
} from 'react'
import {DropdownMenuProvider} from '../DropdownContext/dropdownContext'
import {DropdownNestedMenuProps} from './types'
import {dropdownNestedMenu} from './styles'
import {styled} from 'stitches/config'


const StyledDropdownNestedMenu = styled('div', dropdownNestedMenu)

const DropdownNestedMenuView = (props: DropdownNestedMenuProps) => {
    const {children} = props

    const [open, setOpen] = useState(false)

    const onPress = (ev?: React.MouseEvent) => {
        ev?.stopPropagation?.()
        setOpen((prev) => !prev)
    }

    return (
        <DropdownMenuProvider value={{
            isOpen: open,
            onToggle: onPress,
        }}
        >
            <StyledDropdownNestedMenu>
                {children}
            </StyledDropdownNestedMenu>
        </DropdownMenuProvider>
    )
}

export default DropdownNestedMenuView
